module.exports = __webpack_public_path__ + "airbnb-fav-icon.png?9f5298c9f929519b2fdc0ffda28cd9ab";